import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import OptionExpression from "@bloglovin/inspire-engine/Helpers/OptionExpression.js";
import {
  VISIBILITY_ALWAYS,
  VISIBILITY_NEVER,
  VISIBILITY_WEB_ONLY,
  VISIBILITY_MOBILE_ONLY,
  VISIBILITY_CONDITIONAL,
  normalizeVisibility,
} from "%/dynamic-component-editor/helpers/visibility-surface";

export default class Visible extends BaseOption {
  // A dropdown (VisiblePicker → iSelect) rather than a radio bar: the four
  // options overflowed the inspector's option-row width, wrapping "Mobile only"
  // onto a second line and clipping "Web only". VisiblePicker maps these raw
  // values (two booleans, two strings) to truthy string sentinels internally —
  // iSelect renders a boolean `false` id as an empty placeholder — so the
  // persisted value stays the raw four-way value with no data change.
  static userInterfaceComponent = {
    label: "Visible",
    component: inspectorTools.VISIBLE_PICKER,
    optionDataType: BaseOption.DataType.Boolean,
    props: {
      options: [
        {
          label: "Always",
          value: VISIBILITY_ALWAYS,
          tooltip: "Render on every surface",
        },
        {
          label: "Never",
          value: VISIBILITY_NEVER,
          tooltip: "Render nowhere",
        },
        {
          label: "Web only",
          value: VISIBILITY_WEB_ONLY,
          tooltip: "Render on the web only",
        },
        {
          label: "Mobile only",
          value: VISIBILITY_MOBILE_ONLY,
          tooltip: "Render in the mobile app only",
        },
        {
          label: "Conditional",
          value: VISIBILITY_CONDITIONAL,
          tooltip: "Render only when a boolean expression is true",
        },
      ],
    },
  };

  static defaultValue = true;

  // XXX: Must NOT collapse to a boolean. The previous implementation returned
  // XXX: [true,"true","yes"].includes(configValue), which compiled "web-only" to
  // XXX: false and made the element vanish everywhere. The compiled payload has
  // XXX: to carry the raw four-way value so the mobile renderer can apply its
  // XXX: half of the rule; collapsing erases the distinction MCL needs.
  // XXX: This normalisation IS the migration -- every existing element stores a
  // XXX: boolean and maps forward with no data pass.
  static convertConfigValueToCompiledValue(configValue) {
    // A conditional-visibility expression rides to the payload byte-identical so
    // the client resolves the boolean at render (getOptionValue → resolve). #66
    if (OptionExpression.isToken(configValue)) {
      return configValue;
    }
    return normalizeVisibility(configValue);
  }
}
